import { FC } from 'react'

const ArrowStepIndicatorLightLightMobile: FC<{
  width?: string
  height?: string
}> = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_3)">
        <path d="M12.6905 59.5L0.309525 1V117L12.6905 59.5Z" fill="white" />
        <path d="M12.6905 1H0.309525L12.6905 59V1Z" fill="white" />
        <path d="M12.6905 117H0.309525L12.6905 59V117Z" fill="white" />
        <path d="M0.309525 1L12.6905 59L0.309525 117" stroke="#D1D5DB" />
      </g>
      <defs>
        <clipPath id="clip0_0_3">
          <rect width="13" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default ArrowStepIndicatorLightLightMobile
